import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoAmparo, TipoAmparoProps } from '../../interfaces/catalogos/TipoAmparoInterface';

export const TipoAmparo = () => {

    return new Promise<TipoAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAmparo/', token)
            .then( ({ data } : { data : TipoAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoAmparo = () => {

    return new Promise<TipoAmparoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAmparo/ObtenerTipoAmparo', token)
            .then( ({ data } : { data : TipoAmparoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoAmparo = ( params: TipoAmparoProps ) => {

    return new Promise<TipoAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAmparo/Actualizar', params, token)
            .then( ({ data } : { data : TipoAmparoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAmparo } );
            });

        }

    });

}

export const AgregarTipoAmparo = ( params: TipoAmparoProps ) => {

    return new Promise<TipoAmparoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAmparo/Agregar', params, token)
            .then( ({ data } : { data : TipoAmparoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAmparo } );
            });

        }

    });

}
